import React from 'react';
import { Margin, Row, Column, Icon } from '@upgrade/react-components';
import { mdiCash } from '@mdi/js';
import { Container } from './styles';
import { Text } from '../TypographyPublicSite';
import { toHtmlSanitize } from '../../../utils/remark-html';

const Banner = ({
  className,
  backgroundColor = 'backgroundAccentPL',
  primaryText = 'Get $200 with Rewards Checking Plus',
  primaryTextColor = 'accentSecondary3',
  secondaryText = 'when you start using a new Rewards Checking Plus account and direct deposit $1,000+**',
  secondaryTextColor = 'contentWeak'
}) => {
  return (
    <Row {...{ className }}>
      <Column xs={12}>
        <Container data-color={backgroundColor}>
          <Icon icon={mdiCash} color={primaryTextColor} size="1.5rem" />
          <Margin left="sm">
            <Text as="p" bold color={primaryTextColor} marginBottom="sm">
              {primaryText}
            </Text>
            <Text
              color={secondaryTextColor}
              size="sm"
              dangerouslySetInnerHTML={{ __html: toHtmlSanitize(secondaryText, { removeWrappingPTag: true }) }}
            />
          </Margin>
        </Container>
      </Column>
    </Row>
  );
};

export default Banner;
